<!-- Generated template for the TourGuideComponent component -->
<div class="closeOverlay" (click)="next()"></div> 
    <div class="target" [ngStyle]="{'width': width,'height': height, 'top' : top, 'left' : left}" (click)="next()">
        <div class="text" [ngStyle]="{'width': textWidth,'height': textHeight, 'top' : textTop, 'left' : textLeft}">{{text}}</div>
    </div>

    <div>
        <!--<ion-button>next</ion-button>-->
    </div>
<!-- </div> -->
<!-- <button *ngIf="canButtonGotShow()"
  [ngStyle]="{  'left' : buttonLeft, 'top' : buttonTop}"
  ion-button (click)="gotIt()" round>
      <ion-icon ios="ios-close-circle" md="md-close-circle"></ion-icon>
   {{"CONTENT.TourGuide.Buttons.gotIt" | translate}}
</button> -->
<!--<div>
  {{text}} hallo ich bin baya bin der
</div>-->
